import React from 'react';

const PersonSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M12 21c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm0-19C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M16.5 12v1h.4c-.5 2.5-2.5 4-4.9 4s-4.4-1.5-4.9-4h.4v-1h-2v1h.6c.5 3 2.9 5 5.9 5s5.4-2 5.9-5h.6v-1h-2z"
        />
        <g fillRule="evenodd" clipRule="evenodd" fill="#231F20">
            <path d="M8 8h1v2H8zM15 8h1v2h-1z" />
        </g>
    </svg>
);

PersonSvg.displayName = 'PersonSvg';
export default PersonSvg;
